<script
  lang="ts"
  setup
>
import {
  computed,
  onMounted,
  ref,
} from '#imports'
import { RoutePath } from '~/types/enum'
import LogoSVG from './LogoSVG.vue'
import MobileMenuDialog from './MobileMenuDialog.vue'

const isMenuOpening = ref(false)

const scrollTop = ref<number>(0)

const isOverSlidingHeight = computed(() => scrollTop.value > 24)

const handleScroll = () => {
  scrollTop.value = document.documentElement.scrollTop
  window.addEventListener('scroll', () => {
    scrollTop.value = window.scrollY
  })
}

onMounted(handleScroll)
</script>

<template>
  <header
    key="mobile_header"
    :class="{ 'over-sliding-height': isOverSlidingHeight }"
    :style="isMenuOpening ?'background: #fff;':undefined"
    class="mobile-header"
  >
    <NuxtLinkLocale
      :to="RoutePath.HOME"
      class="logo-link"
      style="display: flex"
    >
      <LogoSVG />
      <span class="logo-title">PikPak</span>
    </NuxtLinkLocale>
    <div class="menu-controller">
      <div
        v-if="!isMenuOpening"
        class="icon icon-menu"
        @click="isMenuOpening = true"
      />
      <div
        v-else
        class="icon icon-close"
        @click="isMenuOpening = false"
      />
    </div>
    <MobileMenuDialog
      :visible="isMenuOpening"
      @close="isMenuOpening = false"
    />
  </header>
</template>

<style lang="less">
.mobile-header {
  z-index: 999;
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  padding-right: 12px;
  align-items: center;
  background: none;
  box-shadow: none;
  position: relative;
  top: 0;
  margin-bottom: -60px;

  &.over-sliding-height {
    background: #fff;
    box-shadow: 0 6px 30px rgba(13, 37, 83, 0.1);
    position: fixed;
  }

  .logo-link {
    display: flex;
    align-items: center;
    text-decoration: none;

    .logo-title {
      color: #000;
      margin-left: 12px;
      font-size: 20px;
      font-weight: 600;
    }
  }
}

.el-collapse {
  border-top: none;

  .el-collapse-item__header {
    height: 54px;
    font-size: 14px;
    font-weight: 400;
    color: var(--color-primary-text);
  }

  a:hover {
    color: #000;
  }
}

.icon {
  width: 24px;
  height: 24px;
}

.icon-menu {
  background: url('assets/images/basic-layout/menu.svg') no-repeat
    center/cover;
}

.icon-close {
  background: url('assets/images/basic-layout/close.svg') no-repeat
    center/cover;
}
</style>
